import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Badge.css';

export const BadgeVariants = {
    TRANSPARENT: 'transparent',
    DARK: 'dark',
    LIGHT: 'light',
    WHITE: 'white',
    ACTIVE: 'active',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    INDIGO: 'indigo',
};

const Badge = ({ color = 'gray', variant = BadgeVariants.TRANSPARENT, className, children }) => (
    <div style={{ color }} className={classNames(css.badge, variant && css[variant], className)}>
        {children}
    </div>
);

Badge.propTypes = {
    variant: PropTypes.oneOf(Object.values(BadgeVariants)),
    color: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
};

export default Badge;
